/* eslint-disable max-len */
import React from 'react';
//////////////////////////////////////////////////

const tel = (color, width, height, bgColor) => (
  <svg
    viewBox='0 0 18 18'
    width={width || 18}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none'>
      <circle
        r='8'
        cx='8'
        cy='10'
        fill={bgColor || '#930000'}
      />
      <path
        fill={color || '#fff'}
        d='M2.745 15.333h-.123c-.067 0-.122-.06-.122-.132v-.402c0-.073.055-.132.122-.132h.485c-.233.167-.364.333-.361.667zm1.26-.127c.008.042.012.084.012.127 0 .367-.271.666-.607.666s-.607-.299-.607-.666a.66.66 0 0 1 .012-.127c.054-.307.299-.54.595-.54s.542.232.595.54zm-.292.127a.36.36 0 0 0-.023-.128c-.045-.121-.153-.206-.28-.206s-.235.085-.28.206c-.016.039-.023.083-.023.128 0 .183.136.333.303.333s.303-.15.303-.333zm-.91-1.099v-2.939c0-.163.121-.296.271-.296h4.313c.149 0 .271.132.271.296v2.939c0 .054-.041.099-.09.099H2.894c-.05 0-.09-.044-.09-.099zm4.247-.321c0 .048.067.087.149.087h.005c.082 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087H7.2c-.083 0-.149.039-.149.087v2.493zm-.607 0c0 .048.067.087.149.087h.005c.083 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087h-.005c-.082 0-.149.039-.149.087v2.493zm-.91 0c0 .048.067.087.149.087h.005c.082 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087h-.005c-.082 0-.149.039-.149.087v2.493zm-.607 0c0 .048.067.087.149.087h.005c.082 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087h-.005c-.082 0-.149.039-.149.087v2.493zm-.91 0c0 .048.067.087.149.087h.005c.082 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087h-.005c-.083 0-.149.039-.149.087v2.493zM3.559 14h.005c.083 0 .149-.039.149-.087V11.42c0-.048-.067-.087-.149-.087h-.005c-.082 0-.149.039-.149.087v2.493c0 .048.067.087.149.087zm1.963 1.206c.008.042.012.084.012.127 0 .367-.271.666-.607.666s-.607-.299-.607-.666a.66.66 0 0 1 .012-.127c.054-.307.299-.54.595-.54s.542.232.595.54zm-.292.127c0-.045-.008-.089-.022-.128-.046-.121-.154-.206-.281-.206s-.235.085-.281.206a.36.36 0 0 0-.022.128c0 .183.136.333.303.333s.303-.15.303-.333zm-.91-.667h-.303a.93.93 0 0 1 .152.333.92.92 0 0 1 .151-.333zm7.18.27v.313c0 .057-.041.103-.09.103l-1.456-.019c-.052-.408-.379-.758-.753-.758s-.749.349-.802.758H5.785c-.027-.207-.118-.389-.251-.519h2.539v-2.942c0-.113.08-.206.181-.206H9.41c.241 0 .686.193.821.42l.835.889a.91.91 0 0 1 .124.46v1.398h.22c.05 0 .09.046.09.103zm-.835-1.779l-.715-.777c-.028-.029-.072-.047-.12-.047H8.714c-.081 0-.147.05-.147.112v.776c0 .063.066.112.147.112h1.83c.119 0 .188-.102.12-.176zm-.884 2.177c0 .367-.272.666-.607.666s-.607-.299-.607-.666.271-.667.607-.667.607.299.607.667zm-.303-.001c0-.184-.136-.333-.303-.333s-.303.149-.303.333.136.333.303.333.303-.15.303-.333zM8.93 3.887c.436 1.52-5.496 5.037-5.982 5.176-.272.078-.602.095-.684-.192-.027-.096.03-.262.152-.478h0l-.712-.785c-.096-.106-.093-.277.007-.363l.067-.058c.122-.104.282-.14.439-.098l.959.26.869-.968-1.931-.724c-.153-.057-.212-.269-.111-.397l.103-.131a.86.86 0 0 1 .692-.336l2.878.039c.719-.612 1.392-1.081 1.834-1.208l.354-.088-.682.642.069.313L8.3 3.488c.319-.004.543.095.629.396zM6.459 7.435l1.356.999c.083.061.187.056.258-.011l.112-.108c.205-.197.263-.529.146-.822l-.47-1.173c-.029-.073-.109-.101-.164-.058l-1.248.973c-.061.047-.055.152.011.201zm4.155 1.088c-.53.256-1.036.5-1.676.681V8a.28.28 0 0 1 .128-.234l.478-.315a.35.35 0 0 1 .164-.049h.768v-.438h.864v.438h.662c.107 0 .195.084.195.189v.261c-.609.201-1.099.438-1.582.672zm-.138-1.993v.228h.864V6.53c0-.117-.097-.211-.218-.211h-.429c-.12 0-.218.094-.218.211zm-.502-.663c.062 0 .121-.012.175-.035a.34.34 0 0 0 .272.136c.037 0 .071-.007.104-.018-.002.129.091.22.207.22s.208-.09.208-.202-.093-.202-.208-.202a.32.32 0 0 0 .025-.124c0-.18-.15-.326-.336-.326-.07-.181-.242-.316-.447-.316a.44.44 0 0 0-.447.433.44.44 0 0 0 .447.433zm4.376 4.243c-.043.064-.044.146-.001.209l.258.374c.094.137-.015.318-.184.306l-5.729-.436c-.156-.012-.286-.118-.326-.265-.035-.128-.068-.287-.068-.428 0-.29.12-.344.366-.401 2.199-.509 2.804-1.735 6.473-1.936a.15.15 0 0 1 .159.167c-.109.781-.493 1.737-.948 2.41zm-.28-.917c0-.052-.044-.094-.097-.094s-.097.042-.097.094c0 .146-.1.268-.237.308v-.65c.073-.035.124-.108.124-.192 0-.119-.099-.215-.222-.215s-.222.096-.222.215c0 .085.051.158.125.193v.649c-.137-.041-.237-.163-.237-.308 0-.052-.044-.094-.097-.094s-.097.042-.097.094c0 .283.237.513.529.513s.529-.23.529-.513z'
      />
      <circle
        r='3'
        cx='14'
        cy='4'
        fill={bgColor || '#930000'}
      />
      <circle
        r='3'
        cx='14'
        cy='4'
        strokeWidth='0.4'
        stroke={color || '#930000'}
      />
      <path
        fill={color || '#fff'}
        d='M15.337 3.791h-1.128V2.663c0-.051-.07-.163-.209-.163s-.209.111-.209.163v1.128h-1.128c-.051 0-.163.07-.163.209s.111.209.163.209h1.128v1.128c0 .051.07.163.209.163s.209-.111.209-.163V4.209h1.128c.051 0 .163-.07.163-.209s-.111-.209-.163-.209z'
      />
    </g>
  </svg>
);

const temperatureCold = (color, width, height) => (
  <svg
    viewBox='0 0 15 20'
    width={width || 15}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#2aaae3'}>
      <path d='M7.806 12.88V2.724A2.73 2.73 0 0 0 5.082 0a2.73 2.73 0 0 0-2.724 2.724V12.88C-.421 15.378 1.352 20 5.082 20s5.503-4.621 2.724-7.12zM6.343 8.944H3.82v-6.22a1.26 1.26 0 0 1 1.26-1.26c.696 0 1.262.565 1.262 1.26v6.22z' />
      <circle cx='5' cy='15' r='5' />
      <path d='M15 2.942h-4v-.884h4z' />
    </g>
  </svg>
);

const temperatureHot = (color, width, height) => (
  <svg
    viewBox='0 0 15 20'
    width={width || 15}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#DA0606'}>
      <path d='M7.806 12.88V2.724A2.73 2.73 0 0 0 5.082 0a2.73 2.73 0 0 0-2.724 2.724V12.88C-.421 15.378 1.352 20 5.082 20s5.503-4.621 2.724-7.12zM6.343 8.944H3.82v-6.22a1.26 1.26 0 0 1 1.26-1.26c.696 0 1.262.565 1.262 1.26v6.22z' />
      <circle cx='5' cy='15' r='5' />
      <path d='M12.966 2.005H15v.825h-2.034V5h-.932V2.83H10v-.825h2.034V0h.932z' />
    </g>
  </svg>
);

const temperatureSensor = (color, width, height) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox='0 0 200 200'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      fill={color || '#666666'}
      d='M94.5 11.5c14.815-1.284 22.815 5.383 24 20a12.93 12.93 0 0 0-5 .5c-1.333 1.333-1.333 2.667 0 4a12.95 12.95 0 0 0 5 .5v13c-2.561-.053-4.561.947-6 3 1.222 2.478 3.222 3.478 6 3v13c-2.778-.478-4.778.522-6 3 1.439 2.053 3.439 3.053 6 3v13a12.95 12.95 0 0 0-5 .5c-1.333 1.333-1.333 2.667 0 4a12.95 12.95 0 0 0 5 .5v14a12.93 12.93 0 0 0-5 .5c-1.333 1.333-1.333 2.667 0 4a12.93 12.93 0 0 0 5 .5 12.93 12.93 0 0 0 .5 5c19.955 15.441 23.621 34.108 11 56-15.798 16.914-33.631 19.414-53.5 7.5-16.914-15.798-19.414-33.631-7.5-53.5a77.78 77.78 0 0 1 11-10l1-91c2.017-7.181 6.517-11.848 13.5-14zm3 20c1.951-.273 3.451.393 4.5 2l1.5 98c13.906 5.885 17.406 15.551 10.5 29-7.565 7.84-16.064 9.007-25.5 3.5-7.84-7.565-9.007-16.065-3.5-25.5a25.52 25.52 0 0 1 10.5-7l2-100zm-64 24c7.828-1.007 10.994 2.327 9.5 10-23.333 22.667-23.333 45.333 0 68 1.5 7.833-1.667 11-9.5 9.5C7.979 119.826 4.812 93.992 24 65.5a133.24 133.24 0 0 0 9.5-10zm125 0a24.94 24.94 0 0 1 7 .5c25.521 23.174 28.688 49.008 9.5 77.5l-9.5 9.5c-7.833 1.5-11-1.667-9.5-9.5 23.333-22.667 23.333-45.333 0-68-1.139-3.921-.305-7.254 2.5-10zm-111 12c7.518.388 10.018 4.054 7.5 11-15.333 14-15.333 28 0 42 2.464 5.739.631 9.406-5.5 11-12.458-6.902-18.792-17.568-19-32 .429-13.528 6.095-24.194 17-32zm100 0c2.155-.128 4.155.372 6 1.5 16.248 14.344 19.414 31.177 9.5 50.5-3.436 5.273-7.936 9.273-13.5 12-6.131-1.594-7.964-5.261-5.5-11 11.563-9.569 13.897-20.902 7-34l-8-10c-.623-4.088.877-7.088 4.5-9zm-89 13c7.828-1.007 10.994 2.326 9.5 10-7.333 6-7.333 12 0 18 1.5 7.833-1.667 11-9.5 9.5-9.806-9.043-11.639-19.543-5.5-31.5a46.08 46.08 0 0 0 5.5-6zm75 0c7.804.275 12.97 4.275 15.5 12 2.711 10.398-.122 18.898-8.5 25.5-7.833 1.5-11-1.667-9.5-9.5 7.333-6 7.333-12 0-18-1.139-3.921-.305-7.254 2.5-10z'
    />
  </svg>
);

const terminal = (color, width, height, bgColor) => (
  <svg
    viewBox='0 0 17 18'
    width={width || 24}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='8.1'
      cx='8.1'
      cy='8.1'
      fill={bgColor || '#930000'}
    />
    <g fill={color || '#fff'}>
      <path d='M6.01 12.484h1.916v.784H6.01zM6.01 11.265h1.916v.783H6.01zM6.01 13.616h1.916v.784H6.01zM6.01 10.132h1.916v.784H6.01zM2.7 10.132h.61V14.4H2.7zM8.274 12.484h1.916v.784H8.274zM3.658 13.616h1.916v.784H3.658zM3.658 11.265h1.916v.783H3.658zM3.658 10.132h1.916v.784H3.658zM3.658 12.484h1.916v.784H3.658zM8.274 13.616h1.916v.784H8.274zM10.626 10.132h1.916v.784h-1.916zM8.144 7.084l-4.834 2.7h9.667l-4.833-2.7zm.77 2.115a.194.194 0 0 1-.193.195H7.566a.194.194 0 0 1-.192-.195V8.03c0-.107.086-.194.192-.194h1.155c.106 0 .192.087.192.194V9.2z' />
      <path d='M7.752 8.216h.783V9h-.783zM8.274 11.265h1.916v.783H8.274z' />
      <path d='M8.1 6.3 2.7 9.279v.33l5.307-2.927a.193.193 0 0 1 .186 0L13.5 9.61v-.331L8.1 6.3zM12.89 10.132h.61V14.4h-.61zM8.274 10.132h1.916v.784H8.274zM10.626 11.265h1.916v.783h-1.916zM10.626 13.616h1.916v.784h-1.916zM10.626 12.484h1.916v.784h-1.916z' />
    </g>
    <g transform='translate(9.72)'>
      <circle
        r='3.24'
        cx='3.402'
        cy='3.402'
        fill={color || '#fff'}
      />
      <path
        fill={bgColor || '#930000'}
        d='M6.043 1.037A3.518 3.518 0 0 0 3.539 0a3.542 3.542 0 0 0-2.504 6.042A3.519 3.519 0 0 0 3.54 7.078c.946 0 1.835-.368 2.504-1.036a3.542 3.542 0 0 0 0-5.005zm-.455 4.55a2.879 2.879 0 0 1-2.049.848 2.898 2.898 0 0 1 0-5.791 2.898 2.898 0 0 1 2.049 4.943z'
      />
      <path
        fill={bgColor || '#930000'}
        d='M5.422 3.244H3.866V1.688a.311.311 0 0 0-.622 0v1.556H1.688a.311.311 0 0 0 0 .622h1.556v1.556a.311.311 0 0 0 .622 0V3.866h1.556a.311.311 0 0 0 0-.622z'
      />
    </g>
  </svg>
);

const terminalStop = (color, stroke, width, height, bgColor) => (
  <svg
    viewBox='0 0 32 32'
    width={width || 32}
    height={height || 32}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='15'
      cx='16'
      cy='16'
      fill={bgColor || '#fff'}
      stroke={stroke || '#353535'}
    />
    <g fill={color || '#930000'}>
      <path d='M13 20h3v1h-3zm0-2h3v1h-3zm0 4h3v1h-3zm0-6h3v1h-3zm-6 0h1v7H7zm10 4h3v1h-3zm-8 2h3v1H9zm0-4h3v1H9zm0-2h3v1H9zm0 4h3v1H9zm8 2h3v1h-3zm4-6h3v1h-3zm-4.5-6L8 15h17l-8.5-5zm1.354 3.918c0 .199-.152.361-.338.361h-2.03c-.187 0-.338-.162-.338-.361v-2.165c0-.199.152-.361.338-.361h2.03c.187 0 .338.162.338.361v2.165zM16 12.4h1v1h-1zm1 5.6h3v1h-3z' />
      <path d='M16.5 9L7 14.4v.6l9.336-5.307a.33.33 0 0 1 .328 0L26 15v-.6L16.5 9zm8.5 7h1v7h-1zm-8 0h3v1h-3zm4 2h3v1h-3zm0 4h3v1h-3zm0-2h3v1h-3z' />
    </g>
  </svg>
);

const threeDots = (color, width, height) => (
  <svg
    viewBox='0 0 5 17'
    width={width || 5}
    height={height || 17}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#666666'}
      d='M2.133 4.267c1.177 0 2.134-.957 2.134-2.134S3.31 0 2.133 0 0 .957 0 2.133.957 4.267 2.133 4.267zm0 7.733C.957 12 0 12.957 0 14.133s.957 2.134 2.133 2.134 2.134-.957 2.134-2.134S3.31 12 2.133 12zm0-6C.957 6 0 6.957 0 8.133s.957 2.134 2.133 2.134 2.134-.957 2.134-2.134S3.31 6 2.133 6z'
    />
  </svg>
);

const threePointer = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5zM3.75 9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zM7.5 9a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 7.5 9zm3.75 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z'
    />
  </svg>
);

const time = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#91979a'}
      d='M7 14A7 7 0 0 0 7 0a7 7 0 0 0 0 14zM6 3a1 1 0 1 1 2 0v3h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1V3z'
    />
  </svg>
);

const tollRoad = (color, width, height) => (
  <svg
    viewBox='0 0 58 58'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#000'}
      d='M22 41c-.011-6.995 3.834-13.427 10-16.73V2c-.003-1.103-.897-1.997-2-2H19v12a3 3 0 1 1-6 0V0H2C.897.003.003.897 0 2v54c.003 1.103.897 1.997 2 2h11V46a3 3 0 1 1 6 0v12h11c.535-.001 1.047-.217 1.42-.6A19 19 0 0 1 22 41zM5 30a1 1 0 1 1-2 0V9a1 1 0 1 1 2 0zM5 5a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0zm14 29c0 .1-.01.2-.02.3a3.1 3.1 0 0 1-.2.81c-.531 1.337-1.937 2.107-3.349 1.836S12.998 35.438 13 34V24a3 3 0 0 1 6 0zm23 15.87c1.766-.454 3-2.047 3-3.87s-1.234-3.416-3-3.87zM41 24c-9.389 0-17 7.611-17 17s7.611 17 17 17 17-7.611 17-17a17 17 0 0 0-17-17zM30.86 47.41a1 1 0 0 1-.85 1.53.99.99 0 0 1-.85-.47A14 14 0 0 1 27 41a13.84 13.84 0 0 1 2.21-7.54 1 1 0 0 1 1.729.082 1 1 0 0 1-.049.998 11.98 11.98 0 0 0-.03 12.87zM47 46a5.99 5.99 0 0 1-5 5.91V53a1 1 0 1 1-2 0v-1.09A5.99 5.99 0 0 1 35 46a1 1 0 1 1 2 0 3.99 3.99 0 0 0 3 3.87v-7.96c-2.886-.485-5-2.983-5-5.91s2.114-5.425 5-5.91V29a1 1 0 1 1 2 0v1.09A5.99 5.99 0 0 1 47 36a1 1 0 1 1-2 0 3.99 3.99 0 0 0-3-3.87v7.96A5.99 5.99 0 0 1 47 46zm5.84 2.47a.99.99 0 0 1-.85.47 1 1 0 0 1-.85-1.53 11.98 11.98 0 0 0-.03-12.87 1 1 0 0 1 .792-1.539 1 1 0 0 1 .888.459A13.84 13.84 0 0 1 55 41a14 14 0 0 1-2.16 7.47zM37 36a3.99 3.99 0 0 0 3 3.87v-7.74A3.99 3.99 0 0 0 37 36z'
    />
  </svg>
);

const toxic = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='10'
      cx='10'
      cy='10'
      fill={color || '#353535'}
    />
    <path
      fill='#f3f3f3'
      d='M11.05 12.015a2.14 2.14 0 0 0 1.071-1.833l6.246-.09a8.311 8.311 0 0 0-1.12-4.057 8.323 8.323 0 0 0-3.276-3.178l-2.937 5.44a2.145 2.145 0 0 0-2.128.01L8.9 8.31 5.817 2.976a8.352 8.352 0 0 0-4.183 7.359l6.201-.09A2.129 2.129 0 0 0 9 12.066L6.029 17.57a8.37 8.37 0 0 0 8.155-.119l-3.14-5.432.006-.004zm-.448-.774a1.248 1.248 0 1 1-1.25-2.16 1.248 1.248 0 0 1 1.25 2.16z'
    />
  </svg>
);

const trackingDisabled = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#B22828'}
      d='M9.219.043C7.078.285 5.152 1.426 3.922 3.188a7.48 7.48 0 0 0-1.238 5.387c.164 1.094.539 2.258 1.109 3.461l.246.508-.723.723-.719.719.422.418.418.422.605-.605.617-.586.473.719c1.043 1.578 2.402 3.23 3.836 4.656l.945.91.121.086.953-.949c3.664-3.66 5.852-7.301 6.34-10.559a9.16 9.16 0 0 0-.02-2.383c-.211-1.191-.644-2.184-1.383-3.152l-.27-.355.871-.871.875-.875-.422-.418-.418-.422-.875.875-.871.871-.328-.25C13 .383 11.051-.164 9.219.043zm1.437 1.172c.746.078 1.453.289 2.129.625.375.188 1.027.605 1.125.723.043.051-.086.195-.852.961l-.898.898-.23-.148c-.934-.598-2.254-.711-3.297-.277-1.059.438-1.84 1.293-2.172 2.391-.098.32-.105.41-.109.996-.004.516.012.699.07.914.098.363.266.762.438 1.047l.145.234-1.031 1.031-1.051 1.031c-.012 0-.047-.066-.086-.148-.477-1.074-.574-1.328-.758-1.996-.48-1.75-.391-3.281.277-4.711 1.121-2.406 3.68-3.855 6.301-3.57zm4.363 2.484a5.79 5.79 0 0 1 .875 1.59c.457 1.289.449 2.719-.02 4.328-.715 2.465-2.703 5.543-5.242 8.117l-.633.645-.539-.551c-1.332-1.359-2.695-3.074-3.609-4.527l-.344-.547 1.168-1.168 1.168-1.168.227.141a3.56 3.56 0 0 0 1.793.523c.414.016.578.004.879-.059 1.082-.223 1.98-.891 2.5-1.855a3.45 3.45 0 0 0 .438-1.746c0-.719-.172-1.352-.52-1.91l-.156-.25.891-.895c.488-.488.902-.891.918-.891s.109.102.207.223zm-4.453 1.27c.199.039.723.258.723.301 0 .012-.774.797-1.715 1.738L7.855 8.727l-.117-.25a2.56 2.56 0 0 1 .121-2.371c.168-.281.547-.66.828-.828.57-.34 1.219-.445 1.879-.309zm1.719 1.406a2.6 2.6 0 0 1-.07 2.238c-.168.328-.711.859-1.043 1.027-.719.355-1.594.367-2.27.027l-.203-.105 1.715-1.715 1.738-1.715c.012 0 .074.109.133.242z'
    />
  </svg>
);

const trackingEnabled = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 18}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#55921f'}
      d='M8.925 1.739c-2.813.371-5.254 2.156-6.469 4.73-.762 1.613-.977 3.52-.598 5.289.484 2.25 1.926 4.25 3.91 5.418 1.27.746 2.875 1.188 4.16 1.141.328-.016.387-.027.523-.121.082-.059.195-.172.25-.254.082-.121.098-.187.098-.441s-.016-.32-.098-.441a1.15 1.15 0 0 0-.246-.25c-.137-.094-.203-.105-.789-.152-1.039-.082-1.812-.285-2.609-.684-1.324-.656-2.363-1.691-3.016-2.996-1.512-3.02-.516-6.707 2.309-8.551 3.09-2.016 7.215-1.148 9.23 1.938 1.445 2.223 1.437 5.102-.027 7.305l-.25.375c-.027.039-1.203-1.098-1.203-1.164 0-.02.051-.106.113-.195.277-.406.563-1.109.691-1.707.101-.465.101-1.488 0-1.953-.379-1.754-1.602-3.152-3.266-3.742-.582-.203-.926-.258-1.641-.258s-1.059.055-1.641.258c-.746.266-1.293.613-1.879 1.199-.734.734-1.168 1.531-1.387 2.543-.102.465-.102 1.488 0 1.953.219 1.012.652 1.809 1.387 2.543.91.91 1.973 1.391 3.234 1.469.48.027.676-.027.883-.258a.83.83 0 0 0-.203-1.289c-.133-.07-.258-.098-.613-.125a3.3 3.3 0 0 1-2.234-1.066c-.574-.633-.867-1.387-.867-2.25a3.18 3.18 0 0 1 .973-2.348 3.18 3.18 0 0 1 2.348-.973 3.18 3.18 0 0 1 2.348.973c.351.355.582.699.742 1.117.195.5.242.789.219 1.367a2.85 2.85 0 0 1-.309 1.305l-.117.25-.633-.633-.637-.637.035-.211c.102-.664-.301-1.41-.922-1.699a1.66 1.66 0 0 0-2.371 1.25 1.68 1.68 0 0 0 .918 1.727c.313.145.688.211.953.16l.195-.035 2.418 2.418 2.57 2.512c.351.203.707.156.996-.137.281-.277.34-.645.152-.969-.039-.07-.074-.145-.074-.168s.106-.18.238-.355c.832-1.125 1.379-2.512 1.559-3.977.051-.426.051-1.383-.004-1.867-.312-2.852-2.129-5.379-4.754-6.617a8.71 8.71 0 0 0-2.605-.734 11.71 11.71 0 0 0-1.992.02z'
    />
  </svg>
);

const trailer = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 21 15'
    width={width || 21}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M2.277.24h16.381a2 2 0 0 1 2 2v8.02a2 2 0 0 1-2 2h-1.557c-.256 1.809-1.044 2.713-2.365 2.713s-2.121-.418-2.402-1.255c-.264.837-1.06 1.255-2.388 1.255s-2.105-.904-2.333-2.713h-3.24v2.713h-1.7V12.26h-.396a2 2 0 0 1-2-2V2.24a2 2 0 0 1 2-2z'
    />
    <g fill={subColor || '#cacaca'}>
      <path d='M1.63 2.935h1.304v6.196H1.63zm3.62 0h1.304v6.196H5.25zm3.75 0h1.304v6.196H9zM12.75 3h1.304v6.196H12.75zm3.75 0h1.304v6.196H16.5z' />
      <circle r='1.141' cx='14.543' cy='12.554' />
      <circle r='1.141' cx='10.304' cy='12.554' />
    </g>
  </svg>
);

const trailerFour = (color, width, height) => (
  <svg
    viewBox='0 0 50 8'
    width={width || 50}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'}>
      <path d='M0 0h50v4.167H0z' />
      <g stroke='#fff'>
        <circle cx='38.75' r='2.917' cy='4.583' />
        <circle cx='45.417' r='2.917' cy='4.583' />
        <circle cx='25.417' r='2.917' cy='4.583' />
        <circle cx='32.083' r='2.917' cy='4.583' />
      </g>
      <path d='M5 2.5h2.5v4.167H5z' />
    </g>
  </svg>
);

const trailerOnMap = (color, width, height) => (
  <svg
    viewBox='0 0 50 50'
    width={width || 50}
    height={height || 50}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='25'
      cy='25'
      r='22.5'
      strokeWidth='5'
      strokeOpacity='.3'
      fill={color || '#015295'}
      stroke={color || '#015295'}
    />
    <path
      fill='#fff'
      d='M13.49 15.978h22.818a2 2 0 0 1 2 2v11.817a2 2 0 0 1-2 2h-2.68c-.337 2.38-1.374 3.57-3.112 3.57s-2.791-.55-3.16-1.652c-.348 1.101-1.396 1.652-3.142 1.652s-2.77-1.19-3.07-3.57H16.88v3.57h-2.236v-3.57h-1.153a2 2 0 0 1-2-2V17.978a2 2 0 0 1 2-2z'
    />
    <g fill={color || '#015295'}>
      <path d='M13.272 19.525h1.716v8.152h-1.716zm4.762 0h1.716v8.152h-1.716zm4.934 0h1.716v8.152h-1.716zm4.935.086h1.716v8.152h-1.716zm4.934 0h1.716v8.152h-1.716z' />
      <circle r='1.502' cx='30.262' cy='32.182' />
      <circle r='1.502' cx='24.685' cy='32.182' />
    </g>
  </svg>
);

const trailerThree = (color, width, height) => (
  <svg
    viewBox='0 0 50 8'
    width={width || 50}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'} >
      <path d='M0 0h50v4.167H0z' />
      <g stroke='#fff'>
        <circle cx='38.75' r='2.917' cy='4.583' />
        <circle cx='32.083' r='2.917' cy='4.583' />
        <circle cx='45.417' r='2.917' cy='4.583' />
      </g>
      <path d='M5 2.5h2.5v4.167H5z' />
    </g>
  </svg>
);

const trailerThreeTwo = (color, width, height) => (
  <svg
    viewBox='0 0 50 8'
    width={width || 50}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'}>
      <path d='M0 0h50v4.167H0z' />
      <g stroke='#fff'>
        <circle cx='38.75' r='2.917' cy='4.583' />
        <circle cx='26.25' r='2.917' cy='4.583' />
        <circle cx='12.917' r='2.917' cy='4.583' />
        <circle cx='19.583' r='2.917' cy='4.583' />
        <circle cx='45.417' r='2.917' cy='4.583' />
      </g>
      <path d='M5 2.5h2.5v4.167H5z' />
    </g>
  </svg>
);

const trailerTwo = (color, width, height) => (
  <svg
    viewBox='0 0 50 8'
    width={width || 50}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'} >
      <path d='M0 0h50v4.167H0z' />
      <g stroke='#fff'>
        <circle cx='38.75' r='2.917' cy='4.583' />
        <circle cx='45.417' r='2.917' cy='4.583' />
      </g>
      <path d='M5 2.5h2.5v4.167H5z' />
    </g>
  </svg>
);

const train = (color, width, height) => (
  <svg
    viewBox='0 0 24 24'
    width={width || 24}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#347e95'}>
      <path d='M7.325 19.62a.5.5 0 0 0-.705.055l-3 3.5a.5.5 0 1 0 .76.65l3-3.5a.5.5 0 0 0-.055-.704zM20.38 23.175l-3-3.5a.5.5 0 1 0-.76.65l3 3.5a.502.502 0 0 0 .759-.651z' />
      <path d='M19 22H5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1zM12 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM7 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z' />
      <path d='M19.5 14.086V8.81c0-.703-.5-1.32-1.186-1.467l-6.21-1.33a.496.496 0 0 0-.21 0l-6.208 1.33A1.507 1.507 0 0 0 4.5 8.81v5.277c0 .4.156.777.439 1.061l.489.49-.903 2.706a.5.5 0 0 0 .338.64l7 2a.578.578 0 0 0 .136.017.496.496 0 0 0 .137-.019l7-2a.503.503 0 0 0 .338-.64l-.902-2.707.489-.489c.282-.282.439-.659.439-1.059zM12 8c1.377 0 2.5 1.122 2.5 2.5S13.377 13 12 13a2.503 2.503 0 0 1-2.5-2.5C9.5 9.122 10.62 8 12 8zm-6.5 4.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S7.827 14 7 14s-1.5-.673-1.5-1.5zm11.598 3.99-5 1a.46.46 0 0 1-.197 0l-5-1a.5.5 0 1 1 .196-.98l4.902.98 4.902-.98a.5.5 0 1 1 .196.98zM17 14c-.828 0-1.5-.673-1.5-1.5S16.171 11 17 11c.826 0 1.5.673 1.5 1.5S17.826 14 17 14z' />
      <path d='m17.363 2.827-5.242-1.311a.473.473 0 0 0-.242 0l-5.243 1.31A1.498 1.498 0 0 0 5.5 4.283V7.5a.5.5 0 0 0 1 0V4.28a.5.5 0 0 1 .378-.484l5.121-1.28 5.121 1.28a.5.5 0 0 1 .38.485V7.5a.5.5 0 0 0 1 0V4.28c0-.69-.468-1.287-1.137-1.454z' />
      <path d='M12 1.5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 1 0V2a.5.5 0 0 0-.5-.5z' />
      <path d='M13 0h-2c-.828 0-1.5.673-1.5 1.5v1a.5.5 0 0 0 1 0h3a.5.5 0 0 0 1 0v-1C14.5.673 13.826 0 13 0zM17 20H7a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1z' />
    </g>
  </svg>
);

const trash = (color, width, height, fillOpacity) => (
  <svg
    viewBox='0 0 13 15'
    width={width || 13}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      fillOpacity={fillOpacity || 1}
      d='M11.723 1.764H9.556v-1.3C9.556.203 9.327 0 9.044 0c-.027 0-.046.008-.055.017A.072.072 0 0 0 8.953 0H3.787c-.283 0-.502.203-.502.464v1.3H1.109c-.622 0-1.106.447-1.106 1.02v1.673h.96v9.51c0 .574.475 1.012 1.097 1.012h8.712c.622 0 1.106-.438 1.106-1.012v-9.51h.95V2.785c0-.574-.484-1.021-1.105-1.021zM4.29.928h4.251v.836h-4.25V.928zm6.573 13.038c0 .059-.027.084-.091.084H2.06c-.064 0-.092-.025-.092-.084v-9.51h8.895v9.51zm.951-10.439H1.018v-.742c0-.06.027-.093.091-.093h10.614a.08.08 0 0 1 .091.093v.742zM8.258 5.544h1.015v7.679H8.258zm-2.34 0h1.015v7.679H5.918zm-2.341 0h1.015v7.679H3.577z'
    />
  </svg>
);

const trendingDown = (color, width, height) => (
  <svg
    viewBox='0 0 24 24'
    width={width || 24}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#e15141'}
      d='M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z'
    />
  </svg>
);

const trendingUp = (color, width, height) => (
  <svg
    viewBox='0 0 24 24'
    width={width || 24}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#67ac5b'}
      d='M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z'
    />
  </svg>
);

const triangleUp = (color, width, height) => (
  <svg
    viewBox='0 0 14 8'
    width={width || 14}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M13.293 6.293c.63.63.184 1.707-.707 1.707H1.414C.523 8 .077 6.923.707 6.293L6.293.707a1 1 0 0 1 1.414 0l5.586 5.586z'
    />
  </svg>
);

const truck = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 21 15'
    width={width || 21}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M8.006.258c.339-.45 1.335-.007 1.422.42l.062.387a4401.53 4401.53 0 0 1 .06 8.23H8.517L8.475 1.33C7.936.916 7.78.558 8.005.258zM.124 12.679h.699c.177 1.535.935 2.303 2.275 2.303s2.1-.768 2.285-2.303h.204c.142 1.535.892 2.303 2.248 2.303s2.13-.768 2.319-2.303h4.493c.232 1.535 1.028 2.303 2.388 2.303s2.122-.768 2.286-2.303l1.39-.114V9.633a1 1 0 0 0-.752-.969L17.56 8.05c.14-1.27-.073-2.126-.638-2.571s-1.59-.579-3.074-.401c-.059-1.013-.463-1.837-1.214-2.473s-1.577-.823-2.481-.562v7.966H1.17c-.315 0-.917.208-1.046.8-.085.394-.085 1.017 0 1.87z'
    />
    <g fill={subColor || '#cacaca'}>
      <circle cx='3.095' cy='12.603' r='1' />
      <circle cx='7.884' cy='12.603' r='1' />
      <circle cx='17.021' cy='12.603' r='1' />
      <path d='M14.259 6.277c1.113-.05 1.76.018 1.944.207s.256.699.22 1.532H14.26V6.277z' />
    </g>
    <path
      fill={color || '#015295'}
      d='M3.75 10.406c1.337-1.232 2.178-1.91 2.524-2.036.52-.187.962-.13.944 0-.012.088-.36.766-1.044 2.036H3.75z'
    />
  </svg>
);

const truckGroup = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 21 14'
    width={width || 21}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='#353535'>
      <ellipse cx='10.543' cy='9.141' rx='1.375' ry='1.406' />
      <ellipse cx='8.136' cy='8.789' rx='1.031' ry='1.055' />
    </g>
    <path
      fill='#f3f3f3'
      d='M8.082 8.512a.55.55 0 0 0-.543.555.55.55 0 0 0 .543.555.55.55 0 0 0 .543-.555.55.55 0 0 0-.543-.555zm2.533 0a.55.55 0 0 0-.543.555.55.55 0 0 0 .543.555.55.55 0 0 0 .543-.555.55.55 0 0 0-.543-.555z'
    />
    <g fill={color || '#930000'}>
      <path d='M18.756 8.512a.55.55 0 0 0-.542.555.55.55 0 0 0 .542.555.55.55 0 0 0 .543-.555.55.55 0 0 0-.543-.555zM17.562 5.18h2.027c.152 0 .253-.1.253-.251V3.49a1.08 1.08 0 0 0-1.09-1.085h-1.19c-.152 0-.253.101-.253.253v2.27c0 .152.101.253.253.253zm.254-2.27h.937a.57.57 0 0 1 .582.58v1.186h-1.52V2.91zM7.81 1.11c-.162 0-.27.104-.27.26v4.662c0 .156.108.26.27.26s.272-.104.272-.26V1.37c0-.155-.109-.259-.271-.259zm1.448 0c-.163 0-.271.104-.271.26v4.662c0 .156.108.26.271.26s.271-.104.271-.26V1.37c0-.155-.108-.259-.271-.259zm1.628 0c-.163 0-.271.104-.271.26v4.662c0 .156.108.26.271.26s.272-.104.272-.26V1.37c0-.155-.109-.259-.272-.259zm1.448 0c-.163 0-.272.104-.272.26v4.662c0 .156.109.26.272.26a.25.25 0 0 0 .271-.26V1.37c0-.155-.109-.259-.271-.259zm1.447 0c-.163 0-.271.104-.271.26v4.662c0 .156.108.26.271.26s.271-.104.271-.26V1.37c0-.155-.108-.259-.271-.259zm1.629 0c-.164 0-.272.104-.272.26v4.662c0 .156.108.26.271.26s.272-.104.272-.26V1.37c0-.155-.109-.259-.272-.259zm5.193 5.578V3.19c0-.9-.731-1.647-1.613-1.647h-1.916V.257A.24.24 0 0 0 16.822 0H6.234a.24.24 0 0 0-.252.257v6.431a.24.24 0 0 0-.252.257v2.058c0 .155.1.258.252.258h.526c.12.727.745 1.286 1.49 1.286.525 0 .99-.277 1.261-.694.272.417.736.694 1.26.694.747 0 1.37-.559 1.492-1.286h5.084c.121.727.745 1.286 1.491 1.286s1.37-.559 1.491-1.286h.526a.24.24 0 0 0 .252-.258V6.945c0-.154-.1-.257-.252-.257zm-1.613-4.63c.605 0 1.109.514 1.109 1.132v3.498h-3.025v-4.63h1.916zM6.486.514H16.57v6.174H6.486V.514zm1.513 9.518A1.02 1.02 0 0 1 6.99 9.003c0-.565.454-1.029 1.009-1.029s1.008.464 1.008 1.03-.454 1.028-1.008 1.028zm2.52 0a1.02 1.02 0 0 1-1.008-1.029c0-.565.454-1.028 1.009-1.028s1.008.463 1.008 1.028-.454 1.03-1.008 1.03zm8.067 0a1.02 1.02 0 0 1-1.008-1.029c0-.565.454-1.029 1.008-1.029s1.009.464 1.009 1.03-.454 1.028-1.009 1.028zm1.765-1.286h-.274a1.55 1.55 0 0 0-.87-1.148l-.03-.014-.019-.008-.05-.02-.013-.005-.056-.02-.012-.004-.058-.016-.013-.004-.058-.014-.071-.013-.017-.003-.056-.007-.018-.002-.056-.005-.019-.001a1.25 1.25 0 0 0-.15 0l-.018.001-.056.005-.019.002-.055.007-.074.013-.015.003-.058.014-.013.004-.058.016-.012.004-.056.02-.013.005-.05.02-.019.008-.03.013a1.55 1.55 0 0 0-.87 1.15H12.01a1.55 1.55 0 0 0-.87-1.15l-.03-.013-.019-.008-.049-.02-.012-.006-.056-.02-.013-.004-.128-.034-.015-.003-.057-.01-.017-.003-.055-.007-.02-.002-.055-.005-.019-.001c-.055-.003-.11-.002-.165.001l-.024.002-.068.007c-.008 0-.015.002-.022.003a1.51 1.51 0 0 0-1.056.678c-.237-.368-.623-.615-1.056-.678l-.022-.003-.067-.007-.025-.002a1.49 1.49 0 0 0-.165-.001l-.019.001-.056.005-.02.003-.055.007-.074.013-.014.003-.058.014-.013.004-.058.016-.013.004-.055.02-.014.005-.05.02-.019.008-.03.013c-.45.21-.784.637-.87 1.15h-.272V7.202h14.116v1.543z' />
      <path d='M17.58 5.921h.543c.163 0 .271-.111.271-.277s-.108-.278-.27-.278h-.544c-.163 0-.271.111-.271.278s.108.277.271.277z' />
    </g>
    <g fill={subColor || '#cacaca'}>
      <rect rx='1' y='4.688' x='10.313' width='4.01' height='6.445' />
      <path d='M0 10.066h14.828v2.141H0zM.674 2.93h10.11v7.136H.674z' />
    </g>
    <path
      fill={color || '#930000'}
      d='M2.306 11.569c-.293 0-.532.253-.532.563s.24.564.532.564.532-.254.532-.564-.24-.563-.532-.563zm2.484 0c-.294 0-.533.253-.533.563s.24.564.532.564.532-.254.532-.564-.24-.563-.532-.563zm7.98 0c-.292 0-.531.253-.531.563s.24.564.532.564.532-.254.532-.564-.24-.563-.532-.563zM11.6 8.188h1.987c.149 0 .248-.102.248-.256v-1.46c0-.614-.472-1.1-1.068-1.1H11.6c-.149 0-.248.102-.248.255v2.305c0 .154.1.256.248.256zm.249-2.304h.918a.57.57 0 0 1 .571.589v1.203h-1.49V5.884zM2.04 4.057c-.16 0-.266.105-.266.263v4.732c0 .158.106.263.266.263s.266-.105.266-.263V4.32c0-.158-.107-.263-.266-.263zm1.419 0c-.16 0-.266.105-.266.263v4.732c0 .158.106.263.266.263s.266-.105.266-.263V4.32c0-.158-.107-.263-.266-.263zm1.596 0c-.16 0-.266.105-.266.263v4.732c0 .158.107.263.266.263s.266-.105.266-.263V4.32c0-.158-.106-.263-.266-.263zm1.419 0c-.16 0-.266.105-.266.263v4.732c0 .158.106.263.266.263s.266-.105.266-.263V4.32c0-.158-.106-.263-.266-.263zm1.419 0c-.16 0-.266.105-.266.263v4.732c0 .158.106.263.266.263s.266-.105.266-.263V4.32c0-.158-.106-.263-.266-.263zm1.597 0c-.16 0-.267.105-.267.263v4.732c0 .158.107.263.266.263a.25.25 0 0 0 .267-.263V4.32c0-.158-.107-.263-.267-.263zm5.091 5.661v-3.55c0-.914-.716-1.671-1.581-1.671h-1.88V3.19c0-.157-.099-.261-.247-.261H.494c-.148.001-.247.105-.247.262v6.527C.1 9.718 0 9.823 0 9.98v2.09c0 .156.099.26.247.26h.516c.118.739.73 1.306 1.461 1.306.515 0 .97-.28 1.236-.704.266.423.721.704 1.236.704.731 0 1.343-.567 1.461-1.306h4.985c.12.739.73 1.306 1.462 1.306s1.343-.567 1.462-1.306h.515c.149 0 .247-.104.247-.26V9.98c0-.156-.098-.26-.247-.26zM13 5.018c.593 0 1.087.523 1.087 1.15v3.55h-2.966v-4.7H13zM.74 3.453h9.886v6.266H.741V3.452zm1.483 9.66c-.543 0-.988-.47-.988-1.044s.445-1.044.988-1.044.989.47.989 1.044-.445 1.044-.989 1.044zm2.472 0c-.544 0-.989-.47-.989-1.044s.445-1.044.989-1.044.988.47.988 1.044-.445 1.044-.988 1.044zm7.908 0c-.544 0-.988-.47-.988-1.044s.444-1.044.988-1.044.989.47.989 1.044-.445 1.044-.989 1.044zm1.73-1.305h-.268c-.077-.505-.396-.94-.853-1.166l-.03-.014-.018-.008-.049-.02-.013-.005-.055-.02-.012-.004-.126-.035-.07-.013-.017-.003-.054-.007-.018-.003-.055-.004-.019-.001c-.049-.003-.097-.003-.146 0h-.018l-.055.005-.019.003-.054.007-.072.013-.015.004-.057.013-.012.004-.057.017-.012.004-.055.02-.013.005-.049.02-.018.008-.03.014c-.442.212-.77.646-.853 1.166H6.157c-.077-.504-.395-.939-.852-1.166l-.03-.014-.019-.008-.048-.02-.013-.005-.055-.02-.012-.004-.057-.017-.013-.004-.056-.013-.015-.004-.056-.01-.016-.003-.054-.007-.019-.003-.055-.004-.018-.001a1.46 1.46 0 0 0-.162 0l-.024.003-.067.006-.02.003c-.432.063-.805.322-1.036.69a1.48 1.48 0 0 0-1.035-.69l-.022-.003-.066-.006-.024-.002a1.41 1.41 0 0 0-.162-.001h-.018l-.055.005-.019.003-.054.007-.072.013-.015.004-.057.013-.012.004-.057.017-.012.004-.055.02-.013.005-.049.02-.018.008-.03.014c-.441.212-.769.646-.852 1.166H.494V10.24h13.84v1.567zM11.618 8.94h.532c.16 0 .266-.113.266-.282s-.106-.282-.266-.282h-.532c-.16 0-.266.113-.266.282s.106.282.266.282z'
    />
  </svg>
);

const truckGroup2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#fff'}>
      <path d='M3.414 0a.207.207 0 0 0-.11.035l-.533.352a.21.21 0 0 0-.093.175v7.881h-.221a.84.84 0 0 0-.84.84v2.16H1.26a.208.208 0 0 0-.21.21v1.161c0 .116.094.21.21.21h.906v.556c0 .232.188.42.42.42h1.113a.42.42 0 0 0 .42-.42v-.557h5.764v.557c0 .232.188.42.42.42h1.113a.42.42 0 0 0 .42-.42v-.557h.906a.208.208 0 0 0 .21-.209v-1.162a.208.208 0 0 0-.21-.209h-.357v-2.16a.84.84 0 0 0-.84-.84h-.22V.563a.21.21 0 0 0-.095-.176l-.533-.352a.21.21 0 0 0-.326.176v2.531l-.158-.43a1.47 1.47 0 0 0-1.379-.958h-3.67a1.47 1.47 0 0 0-1.38.968l-.153.42V.211A.212.212 0 0 0 3.414 0zm.494 3.912h6.186V5.98H3.908zm1.666 3.56h2.854a.42.42 0 0 1 .42.42v2.66a.42.42 0 0 1-.42.42H5.574a.42.42 0 0 1-.42-.42v-2.66a.42.42 0 0 1 .42-.42zm-2.527 2.579h.717a.4.4 0 0 1 .398.398v.01c0 .22-.18.397-.398.397h-.717a.396.396 0 0 1-.397-.397v-.01c0-.219.178-.398.397-.398zm7.19 0h.718c.22 0 .397.18.397.398v.01c0 .22-.178.397-.397.397h-.719a.396.396 0 0 1-.396-.397v-.01c0-.219.177-.398.396-.398z' />
      <path d='M5.63 9.848h2.734a.208.208 0 0 0 .208-.207v-.005a.208.208 0 0 0-.208-.208H5.631a.208.208 0 0 0-.208.208v.005c0 .114.093.207.208.207zM8.364 10.688H5.631a.208.208 0 0 1-.208-.208v-.004c0-.115.093-.208.208-.208h2.733c.115 0 .208.093.208.208v.004a.208.208 0 0 1-.208.208zM5.63 8.169h2.734a.208.208 0 0 0 .208-.208v-.004a.208.208 0 0 0-.208-.208H5.631a.208.208 0 0 0-.208.208v.004c0 .115.093.208.208.208zM8.364 9.009H5.631a.208.208 0 0 1-.208-.208v-.005c0-.114.093-.207.208-.207h2.733c.115 0 .208.093.208.207v.005a.208.208 0 0 1-.208.208z' />
    </g>
  </svg>
);

const truckLoad = (color, width, height) => (
  <svg
    viewBox='0 0 21 24'
    width={width || 21}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#8d57b7'}
      d='M19.43 19.616v-3.701a1.44 1.44 0 0 0-1.44-1.44h-.376V.965a.36.36 0 0 0-.161-.3L16.538.06a.36.36 0 0 0-.558.3V4.7l-.272-.735a2.52 2.52 0 0 0-2.363-1.644H7.053a2.52 2.52 0 0 0-2.368 1.66l-.261.719V.361a.36.36 0 0 0-.558-.3l-.914.604a.36.36 0 0 0-.161.3v13.511h-.376a1.44 1.44 0 0 0-1.44 1.44v3.701H.36a.36.36 0 0 0-.36.36v1.99a.36.36 0 0 0 .36.36h1.553v.954a.72.72 0 0 0 .72.72H4.54a.72.72 0 0 0 .72-.72v-.954h9.883v.954a.72.72 0 0 0 .72.72h1.908a.72.72 0 0 0 .72-.72v-.954h1.553a.36.36 0 0 0 .36-.36v-1.99a.36.36 0 0 0-.36-.36h-.614zM4.9 6.705h10.603v3.547H4.9V6.705zm-.247 11.904h-1.23a.68.68 0 0 1-.68-.68v-.017a.68.68 0 0 1 .68-.68h1.23a.68.68 0 0 1 .68.68v.017a.68.68 0 0 1-.68.68zm7.995.201H7.755a.72.72 0 0 1-.72-.72v-4.561a.72.72 0 0 1 .72-.72h4.894a.72.72 0 0 1 .72.72v4.561a.72.72 0 0 1-.72.72zm4.331-.201h-1.23a.68.68 0 0 1-.68-.68v-.017a.68.68 0 0 1 .68-.68h1.23a.68.68 0 0 1 .68.68v.017a.68.68 0 0 1-.68.68zm-4.44-3.166H7.853c-.197 0-.356-.16-.356-.356v-.007c0-.197.16-.356.356-.356h4.687c.197 0 .356.159.356.356v.007c0 .197-.16.356-.356.356zm0-1.44H7.853c-.197 0-.356-.159-.356-.356v-.007c0-.197.16-.356.356-.356h4.687c.197 0 .356.16.356.356v.007c0 .197-.16.356-.356.356zm0 4.32H7.853c-.197 0-.356-.16-.356-.356v-.007c0-.197.16-.356.356-.356h4.687c.197 0 .356.159.356.356v.007c0 .197-.16.356-.356.356zm0-1.44H7.853c-.197 0-.356-.16-.356-.356v-.007c0-.197.16-.356.356-.356h4.687c.197 0 .356.16.356.356v.007c0 .197-.16.356-.356.356z'
    />
  </svg>
);

const truckOnMap = (color, width, height) => (
  <svg
    viewBox='0 0 50 50'
    width={width || 50}
    height={height || 50}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='25'
      cy='25'
      r='22.5'
      strokeWidth='5'
      strokeOpacity='.3'
      fill={color || '#015295'}
      stroke={color || '#015295'}
    />
    <path
      fill='#fff'
      d='M21.674 15.344c.453-.6 1.781-.01 1.896.56l.084.515c.002.014.028 3.672.08 10.973h-1.378L22.3 16.775c-.718-.553-.927-1.03-.626-1.431zM11.166 31.905h.93c.238 2.047 1.249 3.07 3.034 3.07s2.801-1.023 3.047-3.07h.272c.19 2.047 1.19 3.07 2.998 3.07s2.84-1.023 3.092-3.07h5.99c.31 2.047 1.371 3.07 3.184 3.07s2.83-1.023 3.048-3.07l1.853-.151v-4.169a1 1 0 0 0-.752-.968l-3.448-.884c.187-1.692-.096-2.835-.85-3.428s-2.12-.771-4.1-.535c-.077-1.35-.617-2.448-1.617-3.296s-2.103-1.098-3.308-.75v10.621h-11.98c-.42 0-1.222.278-1.393 1.067-.114.526-.114 1.357 0 2.493z'
    />
    <g fill={color || '#015295'} >
      <ellipse rx='1.179' ry='1.237' cx='15.126' cy='31.804' />
      <ellipse rx='1.179' ry='1.237' cx='21.512' cy='31.804' />
      <ellipse rx='1.179' ry='1.237' cx='33.695' cy='31.804' />
      <path d='M30.011 23.37c1.484-.068 2.349.023 2.593.275s.342.932.293 2.043h-2.886v-2.319z' />
    </g>
    <path
      fill='#fff'
      d='M16 28.875c1.782-1.643 2.904-2.548 3.366-2.714.692-.25 1.282-.175 1.258 0-.015.116-.48 1.02-1.391 2.714H16z'
    />
  </svg>
);

const truckOne = (color, width, height) => (
  <svg
    viewBox='0 0 42 21'
    width={width || 42}
    height={height || 21}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'}>
      <path d='M4.348 12.174h37.391v4.348H4.348z' />
      <g stroke='#fff'>
        <circle cx='9.13' r='3.043' cy='16.957' />
        <circle cx='36.087' r='3.043' cy='16.957' />
      </g>
      <path d='M.05 9.511v6.275c0 .406.314.736.699.736h3.655c.773-1.792 2.488-3.041 4.476-3.041s3.703 1.25 4.477 3.04h2.465c.386 0 .7-.329.7-.735V.736c0-.407-.314-.736-.7-.736H6.62a1.68 1.68 0 0 0-1.397.735L.05 9.511zM3.802 7.65l3.094-5.213c.24-.448.534-.697 1.583-.697h5.616c.38 0 .688.312.688.697V7.65a.693.693 0 0 1-.688.699H4.49a.693.693 0 0 1-.688-.699z' />
      <path d='M.87 13.24c0-.468.184-.849.413-.849s.413.38.413.849v1.606c0 .47-.185.85-.413.85s-.413-.38-.413-.85V13.24zm33.494-2.564c.32 0 1.56.531 3.723 1.592h-4.124c-.053-1.061.08-1.592.4-1.592z' />
    </g>
  </svg>
);

const truckStop = (color, width, height, bgColor) => (
  <svg
    width={width || 18}
    height={height || 25}
    viewBox='0 0 98 127'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={bgColor || '#b42025'}
      d='M49.1.5C22.4.5.6 22.2.6 49c0 10.9 3.5 21.1 10.2 29.7L49.1 127l38.3-48.3c6.7-8.6 10.2-18.8 10.2-29.7C97.6 22.3 75.9.5 49.1.5'
    />
    <path
      fill={color || '#fff'}
      d='M69.3 62.5c-2.4 0-4.3 1.9-4.3 4.4 0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3-1.9-4.4-4.3-4.4m-40.3 0c-2.4 0-4.3 1.9-4.3 4.4 0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3-1.9-4.4-4.3-4.4M49.1 3.4C24 3.4 3.6 23.8 3.6 49c0 10.2 3.3 19.9 9.6 27.9l36 45.1 36-45.1c6.3-8.1 9.6-17.7 9.6-27.9-.1-25.1-20.5-45.6-45.7-45.6M79.8 73l-30.6 37.7L18.5 73c-5.2-6.6-8.3-14.9-8.3-24 0-21.5 17.4-38.9 38.9-38.9S88 27.5 88 49c.1 9-3 17.4-8.2 24M41.6 23.4c-1 0-1.8.7-2 1.6h3.9c-.2-.9-1-1.6-1.9-1.6m7.5 0c-1 0-1.8.7-2 1.6H51c-.1-.9-.9-1.6-1.9-1.6m7.6 0c-1 0-1.8.7-2 1.6h3.9c-.1-.9-.9-1.6-1.9-1.6m15.5 5.4s-7.3-1.5-23.2-1.5-22.9 1.5-22.9 1.5l-1.8 15.1s6.1-2.1 24.9-2.1c18.7 0 24.8 2.1 24.8 2.1l-1.8-15.1zm-28.6 59V48.9c1-.1 2.2-.1 3.5-.1v39.9c.7.1 1.4.2 2.1.2s1.3-.1 2-.2V48.8c1.3 0 2.5.1 3.5.1v38.9c1.6-.5 3.1-1.2 4-1.7V45.5c-.3 0-5.7-1.2-9.7-1.1-3.9 0-9.1 1.1-9.4 1.1v40.6c.9.5 2.4 1.2 4 1.7'
    />
  </svg>
);

const truckTwo = (color, width, height) => (
  <svg
    viewBox='0 0 42 21'
    width={width || 42}
    height={height || 21}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'}>
      <path d='M4.348 12.174h37.391v4.348H4.348z' />
      <g stroke='#fff'>
        <circle cx='9.13' r='3.043' cy='16.957' />
        <circle cx='29.13' r='3.043' cy='16.957' />
        <circle cx='36.087' r='3.043' cy='16.957' />
      </g>
      <path d='M.05 9.511v6.275c0 .406.314.736.699.736h3.655c.773-1.792 2.488-3.041 4.476-3.041s3.703 1.25 4.477 3.04h2.465c.386 0 .7-.329.7-.735V.736c0-.407-.314-.736-.7-.736H6.62a1.68 1.68 0 0 0-1.397.735L.05 9.511zM3.802 7.65l3.094-5.213c.24-.448.534-.697 1.583-.697h5.616c.38 0 .688.312.688.697V7.65a.693.693 0 0 1-.688.699H4.49a.693.693 0 0 1-.688-.699z' />
      <path d='M.87 13.24c0-.468.184-.849.413-.849s.413.38.413.849v1.606c0 .47-.185.85-.413.85s-.413-.38-.413-.85V13.24zm33.494-2.564c.32 0 1.56.531 3.723 1.592h-4.124c-.053-1.061.08-1.592.4-1.592z' />
    </g>
  </svg>
);

export {
  tel,
  time,
  toxic,
  train,
  trash,
  truck,
  trailer,
  terminal,
  tollRoad,
  truckOne,
  truckTwo,
  threeDots,
  truckLoad,
  truckStop,
  trailerTwo,
  trendingUp,
  triangleUp,
  truckGroup,
  truckOnMap,
  trailerFour,
  truckGroup2,
  terminalStop,
  threePointer,
  trailerOnMap,
  trailerThree,
  trendingDown,
  temperatureHot,
  temperatureCold,
  trackingEnabled,
  trailerThreeTwo,
  trackingDisabled,
  temperatureSensor,
};

